<button mat-icon-button data-tfa="pave-explicatif_icon" libPegasePaveExplicatifToggler>
  <mat-icon class="pave-explicatif_mat-icon" data-tfa="pave-explicatif_icon" aria-label="Note d’information"
    color="secondary">
    info
  </mat-icon>
</button>
